import React from "react";
import { type DocumentedComponent } from "../../../shared/components/DocumentedComponent";

export type LazyProps = {
    render: () => React.ReactNode,
};

const Lazy: React.FC<LazyProps> = ({ render }) => {
    return render?.();
};

(Lazy as DocumentedComponent).metadata = {
    description: "The `Lazy' component defers construction of its content until the element is actually rendered.  This is useful in cases where a large amount of work is necessary to calculate the input props for child components, but those components may never actually be rendered.  This includes tooltips, popovers, collapsible containers, etc.",
    attributes: [
        { name: "render", type: "function", exactType: "() => React.ReactNode", template: "render={() => $1}", description: "The callback function to invoke when the component is rendered.  This should return the JSX content to display." },
    ],
    isSelfClosing: true,
};

export { Lazy };